import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';

import { Messages } from '../../codegen/Localize';
import { ActionDialogBodyWithInlineErrorMessage,ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState } from '../../commonInfra/dialogs/ActionDialogBodyWithInlineErrorMessage';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { IUserInfo } from '../../userManagement/users/models/IUserInfo';
import { UserSettingsActions } from './UserSettingsActions';

const initialDialogState: ActionDialogBodyWithInlineErrorMessageState = {
};

export default function showResetStartPageDialog(user: IUserInfo): Promise<any> {
    const initialBodyProps: ActionDialogBodyWithInlineErrorMessageProps = {dialogMessage: Messages.resetStartPageConfirmMessage()};
    const dialogInstance = openReactActionDialog<ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState, IResult>({
        title: Messages.resetStartPageConfirmTitle(),
        actionName: Messages.resetStartPageConfirmButton(),
        actionDisabled: (props: ActionDialogBodyWithInlineErrorMessageProps, state: ActionDialogBodyWithInlineErrorMessageState) => { return false; },
        isActionDelete: false,
        dialogWidth: TabDialogWidth.width375px,
        bodyComponent: ActionDialogBodyWithInlineErrorMessage,
        action: (_, state, updateDialogState) => {
            return restartPageAction(updateDialogState, user);
        },
        dismissDialogOnActionFailed: false,
        initialBodyProps,
        initialDialogState
    });
    return Promise.resolve(dialogInstance.result);
}

async function restartPageAction(
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<ActionDialogBodyWithInlineErrorMessageState>>,
    user: IUserInfo): Promise<IResult> {
    const result = await UserSettingsActions.resetStartPage(user);
    if (!result || result.errors) {
        updateDialogState({errorMessage: Messages.resetStartPageError()});
      return Promise.reject();
    }
    getSessionManagementServiceInstance().refreshSessionInfo();
    return Promise.resolve(result);
}